import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import TaxRates2025 from "../components/TaxRates2025"



const TaxRates2025Page = () => (
  <Layout>
    <Seo title="Leano and Cruz, CPAs - 2025 Federal Income Tax Brackets (for taxes due in April 2026)" />
   <TaxRates2025 />
 </Layout>
)

export default TaxRates2025Page

